import chroma from "chroma-js";
import { cn } from "cn";

import getHexColorFromInt from "../../../lib/getHexColorFromInt";

type InputProps = {
  label: string;
  color?: string | number;
  className?: string;
};

export const WSTag = ({ label, color, className }: InputProps) => {
  const localColor = String(color).charAt(0) === "#" ? color : getHexColorFromInt(Number(color));
  const chromaColor = chroma(localColor || "#000000");

  return (
    <div>
      <div
        style={{
          color: chromaColor.darken(1).css(),
          backgroundColor: chromaColor.brighten(1).alpha(0.1).css(),
          border: `1px solid ${chromaColor.brighten(0.4).css()}`,
        }}
        className={cn(
          "inline-flex items-center px-3 py-1 text-xs font-medium uppercase rounded-full leading-sm lg:whitespace-nowrap",
          className
        )}
      >
        {label}
      </div>
    </div>
  );
};

export default WSTag;
